module.exports = __webpack_public_path__ + "img/access.22519ac6.svg";